import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import AppShell from '@/layouts/AppShell.vue'
import { auth } from '@/stores/auth'
import type { Permission } from '@/types'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    permissions?: Permission[]
    public?: boolean
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { title: '登录', public: true },
  },
  {
    path: '/',
    component: AppShell,
    children: [
      { path: '', redirect: '/command' },
      { path: 'command', name: 'command', component: () => import('@/pages/CommandCenter.vue'), meta: { title: '指挥中心', permissions: ['dashboard:read'] } },
      { path: 'content', name: 'content', component: () => import('@/pages/ContentStudio.vue'), meta: { title: '内容工作台', permissions: ['content:read'] } },
      { path: 'agent', name: 'agent', component: () => import('@/pages/AgentStudio.vue'), meta: { title: 'Agent Studio', permissions: ['agent:read', 'vocabulary:read'] } },
      { path: 'operations', name: 'operations', component: () => import('@/pages/OperationsCenter.vue'), meta: { title: '运营中心', permissions: ['operations:read'] } },
      { path: 'people', name: 'people', component: () => import('@/pages/PeopleDevices.vue'), meta: { title: '用户 · 行程 · 设备', permissions: ['people:read', 'device:read'] } },
      { path: 'governance', name: 'governance', component: () => import('@/pages/GovernanceCenter.vue'), meta: { title: '平台治理', permissions: ['health:read', 'provider:read', 'cost:read', 'audit:read', 'ota:read', 'admin:manage'] } },
      { path: 'forbidden', name: 'forbidden', component: () => import('@/pages/ForbiddenPage.vue'), meta: { title: '无访问权限' } },
    ],
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/NotFoundPage.vue'), meta: { title: '页面不存在', public: true } },
]

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  if (!auth.ready.value) await auth.restore()

  if (to.meta.public) {
    if (to.name === 'login' && auth.isAuthenticated.value) return { name: 'command' }
    return true
  }

  if (!auth.isAuthenticated.value) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  if (!auth.canAny(to.meta.permissions)) return { name: 'forbidden' }
  return true
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · Localike Atlas` : 'Localike Atlas'
})
